/**
 * Tutorial guidato delle impostazioni Pagamenti.
 *
 * Un preparativo solo: il riquadro del primo servizio, che il passo dedicato apre
 * per mostrarne i campi. `stopApiPaymentsTour` lo richiude a fine giro, e solo se ad
 * aprirlo e' stato il tutorial. Gli interruttori non si toccano: salvano subito, e
 * qui accendere qualcosa vuol dire cambiare cosa il cliente trova alla cassa.
 */
const SCOPE = '[data-tour-scope="setting-api-payments"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro del primo servizio, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopApiPaymentsTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createApiPaymentsTourSteps() {
	return [
		{
			body: "Qui si accendono i modi di pagare che il cliente trova alla cassa: PayPal, Stripe, Amazon Pay, Google Pay e gli altri. Ogni riga e' un servizio a se', con le sue credenziali e le sue regole.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I metodi di pagamento',
		},
		{
			body: "L'interruttore accende il metodo sulla cassa del sito, e salva subito: appena lo tocchi il pulsante compare o sparisce per chi sta comprando in quel momento. Va acceso dopo aver messo le credenziali, non prima.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Accendere un metodo',
		},
		{
			body: "Il piu' a inizio riga apre la configurazione di quel servizio: chiavi pubbliche e segrete, ambiente di prova o reale, e spesso l'indirizzo da incollare nel pannello del fornitore perche' comunichi l'esito dei pagamenti.",
			before: stopApiPaymentsTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: "Dentro il riquadro ci sono anche i testi per lingua che il cliente legge accanto al metodo, con Copia e Traduci per non riscriverli. Due avvertenze che valgono per tutti i servizi: la chiave segreta e' come una password del conto, e l'ambiente di prova va spento prima di andare online - altrimenti gli ordini sembrano pagati senza che arrivi un euro.",
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Credenziali, testi e ambiente',
		},
	];
}
